module.exports = __webpack_public_path__ + "static/media/_DSC6122.52247c1d.jpg";